let _internals = {
    getCanonicalUrl: function () {
        let url = document.querySelector('body').getAttribute('data-page-url');

        if (url) {
            return url;
        }

        let link = document.querySelector("link[rel='canonical']");
        let canonical = window.location.href;
        if (link !== null) {
            canonical = link.href;
        }

        return canonical.replace(window.location.origin, '');
    },

    getPageType: function () {
        return document.querySelector("body").getAttribute('data-page-type');
    },

    initGA: function () {
        let GA_ID = document.querySelector('body').getAttribute('data-ga-id');

        window.dataLayer = window.dataLayer || [];

        gtag('js', new Date());

        gtag('config', GA_ID, {
            'transport_type': 'beacon',
            'page_path': _internals.getCanonicalUrl(),
            'dimension1': _internals.getPageType(),
            'custom_map': {
                'dimension1': 'dimension1'
            },
        });
    },
    initFbPixel: function (pixelId) {
        !function (f, b, e, v, n, t, s) {
            t = b.createElement(e);
            t.async = !0;
            t.src = v;
            s = b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t, s)
        }(window,
            document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', pixelId); // Insert your pixel ID here.
        fbq('track', 'PageView');
    },
    reachGoal: function (goal_id) {
        gtag('event', goal_id, {
            eventAction: 'click'
        });
    }
};

export const reachGoal = (goal_id) => _internals.reachGoal(goal_id);

export const init = () => {
    let GA_ID = document.querySelector('body').getAttribute('data-ga-id');
    if (GA_ID) {
        _internals.initGA();
    }

    let FB_PIXEL_ID = document.querySelector('body').getAttribute('data-fb-pixel-id');

    if (FB_PIXEL_ID) {
        _internals.initFbPixel(FB_PIXEL_ID);
    }
};
